const style = (theme) => {
  const output = {
    root: {
      width: '100vw',
      height: '100vh',
      fallbacks: {
        height: '-webkit-fill-available',
      },
      overflow: 'hidden',
      position: 'relative',
      zIndex: 1,
      '&::before': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        top: 0,
        width: '50%',
        height: '100%',
        opacity: 0,
        transition: `all 1s ${theme.easings.garret}`,
      },
    },
    rootBackground: {
      '&::before': {
        opacity: 1,
        transitionDelay: 2,
      },
    },
    rootBackgroundRight: {
      '&::before': {
        right: 0,
        background: `linear-gradient(90deg, ${theme.getRgba(theme.colors[6], 0.01)} 0%, ${theme.getRgba(theme.colors[6], 0.8)} 20%)`,
      },
      '& $wrapperTitleRight': {
        '& h2': {
          textAlign: 'right',
        },
        '& $text': {
          textAlign: 'right',
          marginLeft: 'auto',
        },
      },
    },
    rootBackgroundLeft: {
      '&::before': {
        left: 0,
        background: `linear-gradient(-90deg, ${theme.getRgba(theme.colors[6], 0.01)} 0%, ${theme.getRgba(theme.colors[6], 0.8)} 20%)`,
      },
    },
    overview: {
      extend: theme.smallWrapper,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      zIndex: 1,
    },
    wrapperTitle: {
      display: 'flex',
      flexDirection: 'column',
      flex: '0 0 50%',
      width: '50%',
      '& h2': {
        fontSize: 'calc(40px + 2vw)',
        fontFamily: theme.fonts[1],
        color: theme.colors[4],
        fontWeight: 200,
        lineHeight: 1,
        textShadow: `2px 2px 6px ${theme.getRgba(theme.colors[5], 0.5)}`,
        '& .line': {
          '&:not(:first-child)': {
            marginTop: -25,
          },
        },
      },
    },
    wrapperTitleRight: {
      marginLeft: 'auto',
      paddingLeft: 80,
    },
    wrapperTitleLeft: {
      marginRight: 'auto',
      paddingRight: 80,
    },
    text: {
      width: '80%',
      marginTop: 30,
      color: theme.colors[3],
      textShadow: `1px 1px 6px ${theme.getRgba(theme.colors[5], 0.4)}`,
      fontSize: 20,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    wrapperHero: {
      '& h1': {
        fontSize: 80,
      },
    },
  }

  return output
}

export default style
